<template>
  <div style="margin-top: 20px">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="账户余额" style="margin-right: 15px">
        <span class="balance">{{ form.accountBalance }}元</span>
      </el-form-item>
      <el-form-item label="实际可退款金额" style="margin-right: 15px">
        <span class="balance">{{ form.refundableAmount }}元</span>
      </el-form-item>
      <el-form-item label="退款金额(元)" prop="refundAmount" style="margin-right:15px">
        <el-col :span="10">
          <el-input
            v-model="form.refundAmount"
            placeholder="请输入退款金额"
            @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'refundAmount')"
          />
        </el-col>       
        <el-col :span="2" style="margin-left:15px">
          <el-button type="primary" @click="GetEntire">全部</el-button>
        </el-col> 
      </el-form-item>
      <!-- <el-form-item
        label="退款金额"
        prop="refundAmount"
        style="margin-right: 15px"
        :span="12"
      >
        <el-input v-model="refundAmount" placeholder="请输入退款金额" />
      </el-form-item>
      <el-form-item :span="6">
        <el-button type="primary" @click="GetEntire">全部</el-button>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel"> 取 消 </el-button>
      <el-button type="primary" @click="funcSubmit"> 确 定 </el-button>
    </div>
  </div>
</template>
<script>
import { queryRefundData,refund } from "@/api/collectioncoding";
import { isFixed2,gtZero2 } from '@/utils/validate4Form'
export default {
  name: "CodingRefund",
  props: {
    cascadeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      emptyForm: {},
      code: "", 
      form: {           
        accountBalance: "", //账户余额
        refundableAmount: "", //可退金额
        refundAmount: '',
      },
      rules: {
       refundAmount: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { validator: isFixed2, trigger: "blur" },
          { validator: gtZero2 , trigger: "blur"}
        ],
     }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.oldValue['refundAmount'] = ''
      this.form.refundAmount =''
      this.$refs["form"].resetFields();
      this.code = code
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      queryRefundData({ code }).then((response) => {
        this.form = response.data;
      });
    },
    //全部
    GetEntire() {
      this.$set(this.form,'refundAmount',this.form.refundableAmount)
      this.oldValue['refundAmount'] = this.form.refundAmount
    },
    // 提交
    funcSubmit() {
      if(!this.form.refundAmount){
          this.$message({
              message: "请输入退款金额",
              type: "error",
            });
            return;
      }
      const data = {
        code: this.code,
        refundAmount:this.form.refundAmount
      };
      if(parseFloat(this.form.refundAmount) > parseFloat(this.form.refundableAmount)){
            this.$message({
              message: "退款金额不能大于可退款金额",
              type: "error",
            });
            return;
          }
      const rLoading = this.openLoading();
      return new Promise((resolve) => {
        refund(data).then((response) => {
          rLoading.close();
          this.$message({
            message: response.msg,
            type: "success",
          });
          this.$emit("fatherRefundMethod");
          resolve();
        });
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "Refund");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.balance {
  font-weight: bold;
  font-size: 16px;
}
</style>
